
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/profile/tuition-assessment-tool",
      function () {
        return require("private-next-pages/profile/tuition-assessment-tool.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/profile/tuition-assessment-tool"])
      });
    }
  